module.exports = __webpack_public_path__ + "static/media/image-home.f843b132.png";